import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Form fields
  jobTitle: "",
  jobType: "",
  jobLocation: "",
  propertyType: "",
  sitePurpose: "",
  urgency: "",
  jobDescription: "",
  photos: "", // Store stringified photos for form submission
  directContact: null,
  name: "",
  email: "",
  mobile: "",
  
  // Additional fields
  flowType: "getfreequote",
  senderId: null,
  
  // UI state
  currentStep: 1,
  isSubmitting: false,
  showConfirmation: false,
  images: "", // Store stringified images for UI display (Redux serialization requirement)
};

const quoteRequestSlice = createSlice({
  name: "quoteRequest",
  initialState,
  reducers: {
    setField: (state, action) => {
      return { ...state, ...action.payload };
    },
    setStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setSubmitting: (state, action) => {
      state.isSubmitting = action.payload;
    },
    setConfirmation: (state, action) => {
      state.showConfirmation = action.payload;
    },
    setImages: (state, action) => {
      state.images = action.payload;
    },
    resetQuoteRequest: () => initialState,
  },
});

export const { 
  setField, 
  setStep, 
  setSubmitting, 
  setConfirmation, 
  setImages, 
  resetQuoteRequest 
} = quoteRequestSlice.actions;

export default quoteRequestSlice.reducer;
